import { connect } from 'react-redux';

import Checklist from './checklist';
import {
  onLoadChecklists,
  selectChecklist,
  onSubmitChecklist,
  onRestartChecklist,
  selectResult,
  onExportChecklistContent,
  onFinishChecklistRun,
  onStartChecklist,
  onLoadChecklist,
} from '../../reducers/checklist.reducers';
import {
  onSubmitChecklistItemAnswers,
  onLoadChecklistItemAnswers,
} from '../../reducers/checklistItem.reducers';

const mapStateToProps = (state) => ({
  isLoading: state.checklist.isLoading,
  checklist: state.checklist.selectedChecklist,
  checklistItems: state.checklist.checklistItems,
  runStartedAt: state.checklist.runStartedAt,
  correctAnswersCount: state.checklist.correctAnswersCount,
  completed:
    state.checklist.selectedChecklist &&
    !!state.checklist.selectedChecklist.endDate,
  checklists: state.checklist.previewChecklists,
  checklistRuns: state.checklist.checklistRuns,
  checklistToDos: state.checklist.checklistToDos,
  selectedChecklistRun: state.checklist.selectedChecklistRun,
});

const mapDispatchToProps = (dispatch) => ({
  startNewChecklistRun: (checklist) => {
    dispatch(onStartChecklist({ checklistId: checklist.id }));
  },
  loadChecklists: () => dispatch(onLoadChecklists()),
  loadChecklistItemAnswers: (checklistRunId) => {
    dispatch(onLoadChecklistItemAnswers(checklistRunId));
  },
  loadChecklist: (checklistId) => {
    dispatch(onLoadChecklist(checklistId));
  },
  selectChecklist: (checklist) => dispatch(selectChecklist(checklist)),
  onFinishChecklistRun: (checklistRun) => {
    dispatch(onFinishChecklistRun(checklistRun));
  },
  onSubmitAnswer: (checklistItem, answer, checklistRunId) => {
    dispatch(
      onSubmitChecklistItemAnswers({ checklistItem, answer, checklistRunId })
    );
  },
  onSubmitChecklist: () => dispatch(onSubmitChecklist()),
  onRestart: () => dispatch(onRestartChecklist()),
  onExportChecklistContent: (url) => dispatch(onExportChecklistContent(url)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Checklist);



// WEBPACK FOOTER //
// ./src/app/main/checklist/checklist.container.js